/* eslint-disable */
import React, {Component} from 'react';
import {Select, Table, Button, Icon,} from 'antd';

const columns = [
    {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
    },
    {
        title: 'Mã kiện',
        dataIndex: 'bag',
        key: 'bag',
        render: text => <a href="javascript:void(0)" className="a-text--nowrap">{text}</a>,
    }, {
        title: 'Thời gian nhập',
        dataIndex: 'warehousecheck',
        key: 'warehousecheck',
        render: text => <span className="a-text--nowrap">{text}</span>,
    },
    {
        title: '',
        dataIndex: 'action',
        key: 'action',
        fixed: 'right',
        width:92,
        render: text => <div className="group-action-cross-check"><Icon type="check" className="action active"/> <Icon type="question" className="action ml-3"/></div>
    }];

const data = [];
for (let i = 0; i < 15; i++) {
    data.push({
        stt:`${i + 1}`,
        bag: `75011909${i}`,
        warehousecheck: `CNGZ (15:00 29/02/2021)`,
        warehousrecived: `VNHZ (15:00 29/02/2021)`,
    });
}

class Deficient extends Component {
    render() {
        const rowSelection = {
            onChange: this.onSelectChange,
            fixed:true,
        };

        return (
            <React.Fragment>
                <div className="a-content__top a-content__top--page-list mt-0 mr-0">
                    <div className="a-content--page-list__title">
                        <h3 className="a-text--medium a-text--fz-16">DANH SÁCH KIỆN THIẾU (210) <span className="a-text--regular a-text--fz-12 a-text--blue"> - Đã chọn 29</span></h3>
                    </div>
                    <div className="a-content--page-list__top-action">
                        <Button type="primary" className="a-btn a-btn--primary a-btn--h-25 a-btn--font-small a-text--regular primary-special " disabled  icon="check">Đã xử lý
                        </Button>
                        <Button type="primary" className="a-btn a-btn--primary a-btn--h-25 a-btn--font-small a-text--regular primary-special ml-3 " icon="question">Thất lạc
                        </Button>
                    </div>
                </div>
                <div className="a-content__body bg-white a-content__body--page-list mr-0 aheight-100 aoverflow-y pb-0">
                    <Table className={"a-table--antd"} columns={columns} dataSource={data}
                           rowSelection={rowSelection}
                           pagination={false}
                           scroll={{ x: 'fit-content'}}
                    />
                </div>
            </React.Fragment>
        )
    }
}

export default Deficient;